import React from "react";

const InputType = ({ labelText, inputType, value, onChange, name }) => {
  return (
    <>
      <div className="mb-3">
        <label htmlFor="{labelFor}" className="form-label">
          {labelText}
        </label>
        <input
          className="form-control"
          type={inputType}
          name={name}
          value={value}
          onChange={onChange}
        />
      </div>
    </>
  );
};

export default InputType;
